export default __webpack_public_path__ + "static/media/eco_thumbnail.6b3e48d1.webp";